import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Notiflix from 'notiflix';

import './css/SelectDialog.css';

interface SelectDialogProps {
  companies: any[];
  fetchProjects: (companyId: string) => Promise<void>;
  projects: any[];
  onSelect: (projectId: string) => void;
  onClose: () => void;
}

const SelectDialog: React.FC<SelectDialogProps> = ({
  companies,
  fetchProjects,
  projects,
  onSelect,
  onClose,
}) => {
  const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
  const [selectedProject, setSelectedProject] = useState<string | null>(null);

  useEffect(() => {
    if (selectedCompany) {
      fetchProjects(selectedCompany);
    }
  }, [selectedCompany]);

  const handleProjectSelect = () => {
    if (selectedProject) {
      onSelect(selectedProject);
      onClose();
    } else {
      Notiflix.Notify.failure('Please select a project.');
    }
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Select Company and Project</DialogTitle>
      <DialogContent className='dialog-content'>
        <p className='dialog-description'>
          Please select a company first, then choose a project from the list.
        </p>
        <FormControl fullWidth margin='dense' className='form-control'>
          <InputLabel id='company-select-label'>Select a company</InputLabel>
          <Select
            labelId='company-select-label'
            id='company-select'
            value={selectedCompany || ''}
            onChange={(e) => setSelectedCompany(e.target.value as string)}
            className='select'
            label='Package Type'
          >
            <MenuItem value='' className='menu-item'>
              <em>Select a company</em>
            </MenuItem>
            {companies.map((company) => (
              <MenuItem
                key={company.id}
                value={company.id}
                className='menu-item'
              >
                <strong>Id:</strong>&nbsp;{company.id}&nbsp;— &nbsp;
                <strong>Name:</strong>&nbsp;{company.information.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedCompany && projects.length > 0 && (
          <FormControl fullWidth margin='dense' className='form-control'>
            <InputLabel id='project-select-label'>Select a project</InputLabel>
            <Select
              labelId='project-select-label'
              id='project-select'
              value={selectedProject || ''}
              onChange={(e) => setSelectedProject(e.target.value as string)}
              className='select'
              label='Package Type'
            >
              <MenuItem value='' className='menu-item'>
                <em>Select a project</em>
              </MenuItem>
              {projects.map((project) => (
                <MenuItem
                  key={project.id}
                  value={project.id}
                  className='menu-item'
                >
                  <strong>Id:</strong>&nbsp;{project.id}&nbsp;— &nbsp;
                  <strong>Name:</strong>&nbsp;{project.information.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleProjectSelect}
          className='confirm-button'
          color='primary'
          variant='contained'
        >
          Post Data
        </Button>
        <Button onClick={onClose} color='primary' className='cancel-button'>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectDialog;
